import React, { FC, useState, useCallback } from 'react';
import { Box } from '@mui/material';
import Link from 'next/link';
import MenuIcon from '@mui/icons-material/Menu';
import { SxProps, Theme, useMediaQuery, Button } from '@mui/material';
import { headerStyles } from './header.styles';
import Logo from '../../ui-v2/logo/logo.component';
import SearchBar from '../header-search-bar/header-search-bar.component';
import HeaderNav from '../header-nav/header-nav.component';
import BurgerMenu from '../burger-menu/burger-menu.component';
import {
	APP_STORE_APP_PATH,
	GOOGLE_PLAY_APP_PATH,
	os,
	OS_ENUM
} from '../../../constants';
import { clsx, Showable, useStyles } from '@sweatpals/react-ui-kit';

export interface HeaderProps {
	sx?: SxProps<Theme>;
	appLink?: string;
	authText?: string;
	redirectBackOnLogin?: boolean;
}

const Header: FC<HeaderProps> = ({ sx, appLink, authText, redirectBackOnLogin }) => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const handleOpenMenu = useCallback(() => {
		setIsMenuOpen(true);
	}, []);

	const handleCloseMenu = useCallback(() => {
		setIsMenuOpen(false);
	}, []);

	const styles = useStyles(headerStyles);
	const lgMedia = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
	const mdMedia = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

	const handleOpenAppLink = useCallback(() => {
		if (!appLink) return;

		window.location.replace(appLink);

		setTimeout(() => {
			window.location.replace(os === OS_ENUM.iOS ? APP_STORE_APP_PATH : GOOGLE_PLAY_APP_PATH);
		}, 1000);
	}, [appLink]);

	return (
		<Box component="header" sx={clsx(styles.root, sx)}>
			<Box position="relative">
				<Showable show={!isMenuOpen}>
					<Box sx={styles.row}>
						<Box display="flex" alignItems="flex-end" gap="38px">
							<Link href="/" passHref legacyBehavior>
								<Box sx={{ height: '21px' }}>
									<Logo type="light" sx={{ height: "21px" }} layout="fill" />
								</Box>
							</Link>
							{/*<Showable show={lgMedia}>*/}
							{/*	<SearchBar />*/}
							{/*</Showable>*/}
						</Box>
						<Box display="flex" alignItems="center" gap="20px">
							<Showable show={mdMedia}>
								<HeaderNav authText={authText} redirectBackOnLogin={redirectBackOnLogin} />
							</Showable>
							{/*<Showable show={!mdMedia}>*/}
							{/*	<Button*/}
							{/*		onClick={handleOpenAppLink}*/}
							{/*		sx={{*/}
							{/*			p: '6px 10px',*/}
							{/*			borderRadius: '25px',*/}
							{/*			backgroundColor: '#FFFFFF1A',*/}
							{/*			fontFamily: 'Integral CF',*/}
							{/*			fontSize: '13px',*/}
							{/*			fontWeight: 500,*/}
							{/*			lineHeight: '16px',*/}
							{/*			color: 'white',*/}


							{/*			'&:hover': {*/}
							{/*				backgroundColor: '#FFFFFF1A',*/}
							{/*			},*/}

							{/*			'&:active': {*/}
							{/*				backgroundColor: '#FFFFFF1A',*/}
							{/*			},*/}
							{/*		}}*/}
							{/*	>*/}
							{/*		Use app*/}
							{/*	</Button>*/}
							{/*</Showable>*/}
							{/*<Showable show={!lgMedia}>*/}
							{/*	<IconButton*/}
							{/*		onClick={handleOpenMenu}*/}
							{/*		sx={{ color: 'white' }}*/}
							{/*	>*/}
							{/*		<MenuIcon />*/}
							{/*	</IconButton>*/}
							{/*</Showable>*/}
						</Box>
					</Box>
				</Showable>
				<Box sx={styles.relative}>
					<BurgerMenu isOpen={isMenuOpen} onClose={handleCloseMenu} />
				</Box>
			</Box>
		</Box>
	);
};

export default Header;
